import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OnVisibleDirective } from './onVisible.directive';

@NgModule({
  declarations: [OnVisibleDirective],
  imports: [CommonModule],
  exports: [OnVisibleDirective],
})
export class OnVisibleModule {}
